import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listCategories } from "@/lib/adapters/categories";
import { SectionHeading } from "./WhatBringsYouHere";
import { QUICK_CATEGORIES, PLACEHOLDER_CATEGORY_IMAGE } from "@/data/quickCategories";

export default function FeaturedCategories() {
  const [cats, setCats] = useState(QUICK_CATEGORIES);

  useEffect(() => {
    // Try to enrich curated tiles with API product counts. If the API returns
    // nothing (or we're offline), keep the curated list unchanged.
    listCategories({ type: "QUICK" })
      .then((rows) => {
        if (!Array.isArray(rows) || rows.length === 0) return;
        const bySlug = new Map(rows.map((r) => [r.slug, r]));
        setCats((prev) =>
          prev.map((c) => ({
            ...c,
            product_count: bySlug.get(c.slug)?.product_count || 0,
          }))
        );
      })
      .catch(() => {});
  }, []);

  const handleImgError = (e) => {
    if (e.currentTarget.src.endsWith(PLACEHOLDER_CATEGORY_IMAGE)) return;
    e.currentTarget.src = PLACEHOLDER_CATEGORY_IMAGE;
  };

  return (
    <section className="dyntra-container mt-10">
      <SectionHeading title="Featured Categories" href="/shop" testid="cats-heading" />
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-6">
        {cats.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            data-testid={`featured-cat-${c.slug}`}
            className="dyntra-card p-4 flex flex-col items-center text-center group"
          >
            <div className="w-full aspect-square rounded-xl bg-[#F3EFFC] overflow-hidden mb-3 product-img-wrap">
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                onError={handleImgError}
                className="w-full h-full object-cover"
              />
            </div>
            {/* Reserved text row — matches the height of a two-line
                (name + product count) tile so cards without a
                product_count stay the same overall footprint as ones
                with a count, keeping the grid vertically aligned. */}
            <div className="min-h-[46px] flex flex-col items-center justify-start">
              <h3 className="font-display text-sm font-bold text-gray-900 group-hover:text-[#4B2AAD] transition-colors">{c.name}</h3>
              {c.product_count > 0 && (
                <p className="text-xs text-gray-500 mt-0.5">{c.product_count.toLocaleString()} Products</p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
